import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import { Checkbox, IconButton, Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import TuneIcon from '@mui/icons-material/Tune';

export default function ShoeListHeader({
  showFilteredData,
  clientListHeader,
  setClientListHeader,
  dyNamiceHeaderList,
  setCommunicationDetailsDynamiceHeader,
}) {
  const [showHeaderName,setShowHeaderName]=React.useState(true)
  const getOnchangevalue1 = (e, i) => {
    const { name, value } = e.target;
    const onchangeVal1 = [...clientListHeader];
    onchangeVal1[i][name] = e.target.checked;
    setClientListHeader(onchangeVal1);
  };
  const getOnchangevalue = (e, i) => {
    const { name, value } = e.target;
    const onchangeVal1 = [...dyNamiceHeaderList];
    onchangeVal1[i][name] =e.target.checked;
    setCommunicationDetailsDynamiceHeader(onchangeVal1);
  };
  return (
    <PopupState variant="popover" popupId="demo-popup-menu">
      {(popupState) => (
        <>
          <div className="field_box btn">
            
            <Tooltip title="Customize Header">
              <IconButton  {...bindTrigger(popupState)} sx={{background:"linear-gradient(to bottom, #21a9b0, rgb(6, 85, 109))"}}>
                <TuneIcon sx={{color:"#fff"}}/>
            </IconButton>
            </Tooltip>
          </div>
          <div>
          
          </div>
          <React.Fragment>
          <Menu {...bindMenu(popupState)}>
            <div style={{ display: "flex", justifyContent:"space-between" ,alignItems:"center",padding:"0px 5px"}}>
              <p style={{ display:"flex",justifyContent: "flex-start" }}>Customize Header</p>
              <div style={{ display:"flex",justifyContent: "flex-end" }}>
                <IconButton onClick={popupState.close}>
                  <CloseIcon sx={{ color: "red" }} />
                </IconButton>
              </div>
            </div>
            {clientListHeader &&
              clientListHeader.map((header, ind) => {
                return (
                  <React.Fragment key={header.displayName}>
                    {header.name === "Sn." ?
                    <MenuItem>
                    <Checkbox
                        color="primary"
                        name="isShowOnWeb"
                        value={header.isShowOnWeb}
                        onChange={(event) => getOnchangevalue1(event, ind)}
                        checked={header.isShowOnWeb}
                      />
                      {header && header.displayName}{" "}
                      
                    </MenuItem>:""}
                  </React.Fragment>
                );
              })}
            {dyNamiceHeaderList &&
              dyNamiceHeaderList.map((header, ind) => {
                return (
                  <React.Fragment key={header.label}>
                    <MenuItem>
                    <Checkbox
                        color="primary"
                        name="IsShowWeb"
                        value={header.IsShowWeb  }
                        onChange={(event) => getOnchangevalue(event, ind )}
                        checked={header.IsShowWeb}
                      />
                      {header && header.label}{" "}
                      
                    </MenuItem>
                  </React.Fragment>
                );
              })}
            {clientListHeader &&
              clientListHeader.map((header, ind) => {
                return (
                  <React.Fragment key={header.displayName}>
                    {header.name === "Sn." ?
                    "":
                    <MenuItem>
                    <Checkbox
                        color="primary"
                        name="isShowOnWeb"
                        value={header.isShowOnWeb}
                        onChange={(event) => getOnchangevalue1(event, ind)}
                        checked={header.isShowOnWeb}
                      />
                      {header && header.displayName}{" "}
                      
                    </MenuItem>}
                  </React.Fragment>
                );
              })}
          </Menu>
          </React.Fragment>
        </>
      )}
    </PopupState>
  );
}
